module.exports = __webpack_public_path__ + "static/media/rightlg.a8f06462.png";